"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/downloadSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type DownloadSection1sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/app-icon-1.svg" | "/Templates/Doccure/img/icons/app-icon-2.svg" */
    src: string;
    /** Detected variants: "app" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    className?: string;
};
export type HomeThirteenDownloadSectionGeneratedProps = {
    imageWithBasePathImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: DownloadSection1sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "Download the App & Save More on Offers & Discount" */
    sectionDiv0Div0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Get exclusive discounts, wallet cashback, personalized reminders, and fast re-order options only on our mobile app. Health meets convenience." */
    sectionDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "app" */
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/app-img-1.png" */
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "app" */
    sectionDiv0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/app-img-1.png" */
    sectionDiv0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    downloadSection1s: DownloadSection1sItem[];
    downloadSection1sItemWrapper?: (item: DownloadSection1sItem, content: ReactNode) => ReactNode;
    downloadSection1sRenderer?: (defaultNode: ReactNode) => ReactNode;
    downloadSection1sImageVisible?: boolean;
    downloadSection1sImageRenderer?: (item: DownloadSection1sItem, defaultNode: ReactNode) => ReactNode;
    downloadSection1sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: DownloadSection1sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeThirteenDownloadSectionGenerated: FC<HomeThirteenDownloadSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0Div0H20H2Text = "Download the App & Save More on Offers & Discount",
    sectionDiv0Div0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0Div0P0PText = "Get exclusive discounts, wallet cashback, personalized reminders, and fast re-order options only on our mobile app. Health meets convenience.",
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt = "app",
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/app-img-1.png",
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0ImageWithBasePath0ImageAlt = "app",
    sectionDiv0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/app-img-1.png",
    sectionDiv0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0ImageWithBasePath0ImageProps,
    imageWithBasePathImageProps,
    sectionDiv0Div0Div0ClassName,
    downloadSection1s,
    downloadSection1sItemWrapper,
    downloadSection1sRenderer,
    downloadSection1sImageVisible,
    downloadSection1sImageRenderer,
    downloadSection1sImageProps,
}) => {
    return (
        <section className="app-section-thirteen section pt-0">
            <div className="container">
                <div className="app-thirteen">
                    <div className={sectionDiv0Div0Div0ClassName ?? "row align-items-center"}>
                        <div className="col-lg-6">
                            <div className="section-header section-header-thirteen wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0Div0DivDataWowDuration}>
                                {renderNode(sectionDiv0Div0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div0Div0H20H2Text}</h2>
                                ))}
                                <p>{sectionDiv0Div0Div0Div0Div0P0PText}</p>
                            </div>
                            <div className="app-img d-flex align-items-center gap-3">
                                {renderCollectionNode(
                                    downloadSection1s,
                                    (item: DownloadSection1sItem) => (
                                        renderItemNode(downloadSection1sImageVisible, downloadSection1sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "app"} className={item.className ?? "img-fluid img-1"} {...(typeof downloadSection1sImageProps === "function" ? downloadSection1sImageProps(item) : (downloadSection1sImageProps ?? {}))} {...(typeof imageWithBasePathImageProps === "function" ? imageWithBasePathImageProps(item) : (imageWithBasePathImageProps ?? {}))} key={item.key} />
                                        ))
                                    ),
                                    downloadSection1sItemWrapper,
                                    downloadSection1sRenderer
                                )}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="app-img-thirteen">
                                {renderNode(sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                        </div>
                    </div>
                    {renderNode(sectionDiv0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0ImageWithBasePath0ImageRenderer, (
                        <SmartImage src={sectionDiv0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0ImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(sectionDiv0Div0ImageWithBasePath0ImageProps ?? {})} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeThirteenDownloadSectionGenerated;
